<template>
  <ion-menu ref="menu" side="start" menu-id="first" content-id="main">
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button color="primary" />
        </ion-buttons>
        <ion-title v-tl:MOYASE size="large" />
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <ion-item button @click="goTo('/storage')">
          <ion-icon slot="start" :icon="folder" />
          <ion-label v-tl:STORAGE_TITLE />
        </ion-item>
        <ion-item button @click="goTo('/settings')">
          <ion-icon slot="start" :icon="settings" />
          <ion-label v-tl:SETTINGS_TITLE />
        </ion-item>
        <ion-item button @click="goTo('/about')">
          <ion-icon slot="start" :icon="informationCircle" />
          <ion-label v-tl:ABOUT_TITLE />
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-menu>
</template>
<script>
import { defineComponent } from 'vue';
import { settings, folder, informationCircle } from 'ionicons/icons';
import {
    IonMenuButton,
    IonButtons,
    IonTitle,
    IonToolbar,
    IonHeader,
    IonIcon,
    IonLabel,
    IonItem,
    IonList,
    IonContent,
    IonMenu,
    menuController,
} from '@ionic/vue';

export default defineComponent({
    name: 'SideMenu',
    components: {
        IonMenuButton,
        IonButtons,
        IonTitle,
        IonToolbar,
        IonHeader,
        IonIcon,
        IonLabel,
        IonItem,
        IonList,
        IonContent,
        IonMenu,
    },
    setup() {
        return { settings, folder, informationCircle };
    },

    methods: {
        goTo(url) {
            menuController.close();
            this.$router.push(url);
        },
    },
});
</script>